import script from "./ForgotPasswordLink.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordLink.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordLink.vue?vue&type=style&index=0&id=0f20efe6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f20efe6"]])

export default __exports__